import { useSelector } from 'react-redux';

import { MessageMedium } from 'constants/messageMediums';
import { selectFeatureFlags } from 'core/userContext/selectors';

import { NewEmailTemplateModal } from '../NewEmailTemplateModal';
import { NewEmbeddedMessageTemplateModal } from '../NewEmbeddedMessageTemplateModal';
import { NewInAppTemplateModal } from '../NewInAppTemplateModal';
import { NewSimpleTemplateModal } from '../NewSimpleTemplateModal';
import { NewWhatsAppTemplateModal } from '../NewWhatsAppTemplateModal';
import { EmailContent, InAppContent, SimpleContent } from '../constants';

type NewTemplateModalProps = {
  /* Identifier of the template type selected */
  id: string;
  /* Function to Close Modal */
  closeModal: () => void;
  /** the folder where the template is being created */
  currentFolderId: number | null;
};

export const NewTemplateModal = ({
  closeModal,
  currentFolderId,
  id,
  ...props
}: NewTemplateModalProps) => {
  const featureFlags = useSelector(selectFeatureFlags);

  return (
    <>
      {id === 'email' && !featureFlags.TemplateEditEmail && (
        <NewEmailTemplateModal
          closeModal={closeModal}
          // @ts-ignore
          content={EmailContent}
          currentFolderId={currentFolderId}
          id={id}
          {...props}
        />
      )}
      {id === 'email' && featureFlags.TemplateEditEmail && (
        <NewSimpleTemplateModal
          closeModal={closeModal}
          // @ts-ignore
          content={SimpleContent}
          currentFolderId={currentFolderId}
          id={id}
          messageMedium={MessageMedium.Email}
          {...props}
        />
      )}
      {id === 'in-app' && !featureFlags.TemplateEditInApp && (
        <NewInAppTemplateModal
          closeModal={closeModal}
          // @ts-ignore
          content={InAppContent}
          currentFolderId={currentFolderId}
          id={id}
          {...props}
        />
      )}
      {id === 'in-app' && featureFlags.TemplateEditInApp && (
        <NewSimpleTemplateModal
          closeModal={closeModal}
          // @ts-ignore
          content={SimpleContent}
          currentFolderId={currentFolderId}
          id={id}
          messageMedium={MessageMedium.InApp}
          {...props}
        />
      )}
      {id === 'push' && (
        <NewSimpleTemplateModal
          closeModal={closeModal}
          // @ts-ignore
          content={SimpleContent}
          currentFolderId={currentFolderId}
          id={id}
          messageMedium={MessageMedium.Push}
          {...props}
        />
      )}
      {id === 'sms' && (
        <NewSimpleTemplateModal
          closeModal={closeModal}
          // @ts-ignore
          content={SimpleContent}
          currentFolderId={currentFolderId}
          id={id}
          messageMedium={MessageMedium.SMS}
          {...props}
        />
      )}
      {id === 'web-push' && (
        <NewSimpleTemplateModal
          closeModal={closeModal}
          // @ts-ignore
          content={SimpleContent}
          currentFolderId={currentFolderId}
          id={id}
          messageMedium={MessageMedium.WebPush}
          {...props}
        />
      )}
      {id === 'embedded' && (
        <NewEmbeddedMessageTemplateModal
          closeModal={closeModal}
          content={SimpleContent}
          currentFolderId={currentFolderId}
          id={id}
          {...props}
        />
      )}
      {id === 'whatsApp' && (
        <NewWhatsAppTemplateModal
          closeModal={closeModal}
          // @ts-ignore
          content={SimpleContent}
          currentFolderId={currentFolderId}
          id={id}
          {...props}
        />
      )}
    </>
  );
};
